export default __webpack_public_path__ + "svg/who/adigital.svg?0a79f3ed";